const uploader = {
  en: {
    uploader: {
      select_files : "Select File | Select Files",
      upload : "Upload",
      upload_limit: "The Upload limit is {0} file(s)",
      browser_support: "Your browser doesn't have Flash, Silverlight or HTML5 support."
    }
  }
};

module.exports.uploader = uploader;